module.exports = __webpack_public_path__ + "assets/fonts/Icon-Haushaltssaldo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Icon-Haushaltssaldo.svg
// module id = 523
// module chunks = 0